import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

import Pagination from '../Pagination';
import BookDisplay from '../BookDisplay';
import BookDetailsModal from "../../components/BookDetailsModal/BookDetailsModal.js";
import { API_BASE_URL } from "../../Variables";

import './ListView.css';
import back from '../../assets/images/back.svg';

const ListView = () => {
  const { genre } = useParams();                // Get genre from URL
  const navigate = useNavigate();               // Initialize navigate function
  const [books, setBooks] = useState([]);       // Initialize books state
  const [loading, setLoading] = useState(true); // Initialize loading state
  const [error, setError] = useState(null);
  
  // Modal Management
  const [displayBookDetailsModal, setDisplayBookDetailsModal] = useState(false);
  const [selectedBookId, setSelectedBookId] = useState(null);

  // Pagination variables
  const limit = 20;
  const [offset, setOffset] = useState(0);
  const [sort, setSort] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const currentPage = Math.floor(offset / limit) + 1;

  // Function to handle back button click
  const handleBackClick = () => {
    navigate(-1);
  };

  const handleSortChange = (event) => {
    setSort(event.target.value);
    setOffset(0);
  }

  const handleBookClick = (bookId) => {
    setSelectedBookId(bookId);
    setDisplayBookDetailsModal(true);
  };

  // Fetch books dynamically based on the genre
  useEffect(() => {
    const fetchBooks = async () => {
      setLoading(true);
      setError(null);
      try {
        let query = genre.toLowerCase();

        const params = {
          q: query,
          startIndex: offset,
          maxResults: limit,
        };

        // Add sorting parameter if selected
        if (sort) {
          params.orderBy = sort;
        }

        // Use proxy server to query Google Books API
        const response = await axios.get(`${API_BASE_URL}/books-api/`, {
          params
        });

        // Check if totalItems and items are returned
        if (response.data.totalItems > 0 && response.data.items) {
          setTotalPages(Math.ceil(response.data.totalItems / limit));
          setBooks(response.data.items || []);
        } else {
          // Handle the case where no books are returned
          setBooks([]);
          setTotalPages(0);
        }
      } catch (error) {
        setError("Error fetching books. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchBooks();
  }, [genre, offset, limit, sort]);

  return (
    <div className="list-view">
      <div className="list-preview-header">
        <img src={back} alt="Back" className="back-button" onClick={handleBackClick} />
        <h2>{genre}</h2>
        <select value={sort} onChange={handleSortChange}>
          <option value="">Sort by</option>
          <option value="relevance">Relevance</option>
          <option value="newest">Newest</option>
        </select>
      </div>

      <div className="list-view-display">
        {loading ? (
          <p className="loading">Loading...</p>
        ) : error ? (
          <p className="error">
            {error}
          </p>
        ) : books && books.length > 0 ? (
          books.map((book, index) => (
            <BookDisplay key={index} book={book} onBookClick={handleBookClick} />
          ))
        ) : (
          <p className="no-books">No books available in this shelf.</p>
        )}
      </div>

      {totalPages > 0 && (
        <Pagination totalPages={totalPages} setOffset={setOffset} limit={limit} currentPage={currentPage} />
      )}

      {/* Book Details Modal */}
      {displayBookDetailsModal && (
        <BookDetailsModal
          setDisplayBookDetailsModal={setDisplayBookDetailsModal}
          bookId={selectedBookId}
        />
      )}
    </div>
  );
};

export default ListView;